import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { ReportsListView } from '@futrli/views/views/reports/ReportsListView/ReportsListView';

export const useLiveReports = () => {
  const flags = useFlags();
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const reportsView = useApiView(
    useMemo(() => new ReportsListView(workspaceId, organisationId, isConsolidation, flags), [
      flags,
      workspaceId,
      organisationId,
      isConsolidation
    ])
  );

  return {
    liveReports: reportsView.state.reports ?? [],
    isLoading: reportsView.state.isLoading,
    errorLoading: reportsView.state.errorLoading,
    isResourceSharingEnabled: !!flags.resourceSharing
  };
};
